<template>
  <div class="ion-page">
    <ion-header>
      <ion-toolbar color="navbar">
        <ion-title>FormSheets</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content padding>
      <ion-card text-center color="light">
        <ion-card-header>
          <ion-card-title>
            <h1>Make Forms Great Again</h1>
          </ion-card-title>
          <ion-card-subtitle>
            <h2>Collect data to Google Sheets</h2>
          </ion-card-subtitle>
        </ion-card-header>
        <ion-card-content>
          <img :src="google_login" class="login-google" title="Sign in with Google" v-on:click="userLogin" />
        </ion-card-content>
      </ion-card>
      <ion-card color="light">
        <ion-button color="info" expand="block" fill="clear" title="Have questions? Contact us!" v-on:click="contactEmail">
          <h6>Have questions? Contact us!</h6>
        </ion-button>
      </ion-card>
      <footer text-center class="ion-margin-top ion-margin-bottom">
        <p color="medium" class="ion-padding-top">
          <a href="/privacy" title="Privacy Policy">Privacy Policy</a> |
          <a href="/terms" title="Terms of Service">Terms of Service</a>
        </p>
      </footer>
    </ion-content>
  </div>
</template>

<script>
import Helpers from "../mixins/Helpers";
import Plugins from "../mixins/Plugins";
import User from "../models/User";
export default {
  name: "user-login",
  mixins: [Helpers, Plugins],
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.getters.getUser();
    },
    google_login() {
      // return require("../assets/btn_google_signin_light_normal_web.png");
      return require("../assets/btn_google_signin_dark_normal_web.png");
    }
  },
  created() {
    this.showStatusBar();
  },
  mounted() {
    if (this.user && this.user.email) {
      this.showRootPage("forms");
    }
  },
  methods: {
    async userLogin() {
      try {
        await this.$store.dispatch("userLogin");
        this.showRootPage("forms");
      } catch (error) {
        this.showError("Problem Logging In", error);
      }
    },
    contactEmail() {
      this.openEmail("info@dalezak.com?subject=FormSheets");
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 28px;
}
h2 {
  font-size: 24px;
}
ion-icon.ion-icon-large {
  font-size: 64px !important;
}
ion-card-title {
  font-size: 24px;
  font-weight: 500;
}
ion-card-subtitle {
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 15px;
}
ion-button {
  line-height: normal;
}
.button-inner {
  flex-flow: row wrap;
}
footer {
  color: var(--ion-color-medium) !important;
}
a {
  color: var(--ion-color-medium) !important;
}
</style>